export default "__VITE_ASSET__Bnve_eXW__"